import React from 'react';
import { Button } from "@mui/material";
import './Sidebar.css';

const Sidebar = ({ activeTab, handleMenuClick }) => {
    const menuItems = [
        { name: "Synthèse", key: "synthese" },
        { name: "Faits et procédures", key: "faits_procedures" },
        { name: "Motifs", key: "motifs" },
        { name: "Références légales", key: "references_legales" },
        { name: "Résumé", key: "resume" },
        { name: "Décision complète", key: "decision_complet" },
    ];

    return (
        <nav className="justice-sidebar-nav">
            <ul className="sidebar-menu-list">
                {menuItems.map((item) => (
                    <li key={item.key} className="menu-item">
                        <Button
                            variant={activeTab === item.key ? "default" : "ghost"}
                            className={`menu-button ${activeTab === item.key ? "active" : ""}`}
                            onClick={() => handleMenuClick(item.key)}
                        >
                            {item.name}
                        </Button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Sidebar;